module.exports = __webpack_public_path__ + "static/media/04-mom-project.c77fec17.jpg";